import { render, staticRenderFns } from "./SlideGroupRankingList.vue?vue&type=template&id=495af4a7&scoped=true&"
import script from "./SlideGroupRankingList.vue?vue&type=script&lang=js&"
export * from "./SlideGroupRankingList.vue?vue&type=script&lang=js&"
import style0 from "./SlideGroupRankingList.vue?vue&type=style&index=0&id=495af4a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495af4a7",
  null
  
)

export default component.exports